import { action, makeObservable } from 'mobx';
import { Services } from '../../services';
import type { InputEventBindContext } from '../../services/input/event.context';
import type { EventData } from '../../services/input/input.service';
import type { TopologicalEditorPage } from './topological.editor.page';

export class MapModeInputEvents {
	eventContext: InputEventBindContext;
	page: TopologicalEditorPage;

	constructor(page: TopologicalEditorPage) {
		makeObservable(this);

		this.page = page;
	}

	init() {
		this.eventContext = Services.Input.getContext();

		this.eventContext.on(this.eventContext.Code.KeyL, this.toggleLabels, {
			modifiers: {
				ctrl: true,
			},
		});
	}

	@action.bound
	private toggleLabels(evt: EventData) {
		evt.event.preventDefault();
		this.page.controller.map.overlay.toggleViewTitles();
	}

	destroy() {
		if (this.eventContext != null) {
			this.eventContext.destroy();
			this.eventContext = null;
		}
	}
}
